
/* eslint-disable */
const paymentIntentAvailable = function () {
	if (!window.PaymentRequest) {
		return false;
	} else {
		return true;
	}
}
const checkCanMakePayment = function (request) {


	var canMakePaymentPromise = Promise.resolve(true);

	if (request.canMakePayment) {
		canMakePaymentPromise = request.canMakePayment();
	}

	return canMakePaymentPromise
		.then((result) => {
			return result;
		})
		.catch((err) => {
			console.log('Error calling canMakePayment: ' + err);
		});
}

const IsPhonePeIntentAvailable = () => {
    const supportedInstruments = [{
        supportedMethods: "https://mercury.phonepe.com/transact/pay",
        data: {
            url: "upi://pay?pa=cashfree@hdfcbank\u0026pn=Cashfree\u0026tr=89407775\u0026am=1.00\u0026cu=INR\u0026mode=00\u0026purpose=00\u0026mc=5399\u0026tn=Cashfree%20Payment"
        },
    }];

    const details = {
        total: {
            label: 'Total',
            amount: {
                currency: "INR",
                value: "1", // sample amount
            },
        },
        displayItems: [{
            label: 'Original Amount',
            amount: {
                currency: "INR",
                value: "1",
            },
        }],
    };
    return new Promise(function (resolve, reject) {
        let request = null;
        if (!paymentIntentAvailable()) reject(false);
        try {
            request = new PaymentRequest(supportedInstruments, details);
        } catch (e) {
            return reject('Payment Request Error: ' + e.message);
        }
        if (!request) {
            return reject('Web payments are not supported in this browser.');
        }

        let canMakePaymentPromise = checkCanMakePayment(request);
        canMakePaymentPromise.then((result) => {
            return resolve(result);
        }).catch((err) => {
            console.log(err);
            return reject('Error calling checkCanMakePayment: ' + err);
        });
    })
}


const IsGpayIntentAvailable = () => {
	let supportedInstruments = [{
		supportedMethods: "https://tez.google.com/pay",
		data: {
			pa: "cashfree@hdfcbank",
			pn: 'Merchant Name',
			tr: "11223344", // Your custom transaction reference ID
			url: "https://www.cashfree.com",
			mc: '6011', //Your merchant category code
			tn: 'Payment',
		},
	}];

	let details = {
		total: {
			label: 'Total',
			amount: {
				currency: 'INR',
				value: "1", // sample amount
			},
		},
		displayItems: [{
			label: 'Original Amount',
			amount: {
				currency: 'INR',
				value: "1",
			},
		}],
	};
	return new Promise(function (resolve, reject) {
		let request = null;
		if (!paymentIntentAvailable()) reject(false);
		try {
			request = new PaymentRequest(supportedInstruments, details);
		} catch (e) {
			return reject('Payment Request Error: ' + e.message);
		}
		if (!request) {
			return reject('Web payments are not supported in this browser.');
		}

		let canMakePaymentPromise = checkCanMakePayment(request);
		canMakePaymentPromise.then((result) => {
			return resolve(result);
		}).catch((err) => {
			console.log(err);
			return reject('Error calling checkCanMakePayment: ' + err);
		});
	})

}

const gpayAvailable = async () => {
	let gpay = false;
	try {
		gpay = await IsGpayIntentAvailable();
	  } catch(e) {
		gpay = false;
	  }
		return gpay;
}

const phonepeAvailable = async () => {
	let phonepe = false;
  try {
    phonepe = await IsPhonePeIntentAvailable()
  } catch(e) {
    phonepe = false;
  }
	return phonepe;
}

export {
	phonepeAvailable,
	gpayAvailable,
}